function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as BaseMenu } from "@sprout/list-navigation/dist/Menu";
import styled from "styled-components";
import JumpToGroup from "./JumpTo/JumpToGroup";
import useJumpToMoreGroups from "./JumpTo/useJumpToMoreGroups";
const Menu = styled(BaseMenu)`
  padding-left: 16px;
  padding-right: 16px;
  width: 320px;
`;
const AppMoreMenu = (props)=>{
    const menuItems = useJumpToMoreGroups();
    return /*#__PURE__*/ _jsx(Menu, _objectSpread({}, props, {
        placement: "bottom",
        children: menuItems.map(({ group , items  })=>{
            return /*#__PURE__*/ _jsx(JumpToGroup, {
                collapsible: true,
                title: group,
                items: items
            }, group);
        })
    }));
};
export default AppMoreMenu;
